import { Catalog } from '@philips-emr/tws-core';
import { ComponentClass } from '@philips-emr/tws-core/lib/registry/component-info';

import { Node, NodeProps } from '../metadata';

class Renderer<C extends ComponentClass, Component> {

  fromMetadata = (root: Node): Component | null => {
    return this.transverseMetadata(root);
  };

  transverseMetadata = (node: Node): Component | null => {
    const component = this.getComponentByType(node);
    const props = this.getComponentProps(node);

    return this.createElement(component, props, node.children);
  };

  createElement(component: C, props: NodeProps, children?: Node[]): Component | null {
    throw new Error(`Invalid renderer: ${component}, ${props}, ${children}.`);
  }

  getComponentByType({ type }: Node): C {
    try {
      return Catalog.get(type).getComponent() as C;
    } catch(e) {
      throw new Error(`[Renderer]: problem to get component '${type}', error: '${e}'`);
    }
  }

  getComponentProps({ props }: Node): NodeProps {
    return { key: props.uuid, ...props };
  }

}

export default Renderer;
